import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import * as React from "react";
import {useEffect, useState} from "react";
import "./layout/fontawesome6/pro/css/all.min.css";
import "./sidebar.css";
import Footer from "./layout/footer/Footer";
import {Login} from "./components/login/Login";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {Sidebar, SidebarItem} from "@xal3xfx/reactbar";
import {useUserInfo} from "./lib/hooks/useUserInfo";
import {useIntl} from "react-intl";
//@ts-ignore
import png from "./lib/assets/eco_petrol_logo.png";
import {configureApp} from "./lib/config";
import {Circles} from "react-preloaders2";
import styled from "styled-components";
import useSWR from "swr";
import {CSCardResponse, LoginResponse} from "./lib/types/types";
import {Button} from "primereact/button";
import {AuthService} from "./lib/services/auth-service";

import {NotFound} from "./components/404/NotFound";
import {ThemeSwitch} from "./lib/template/theme/ThemeSwitch";
import AdvancePayments from "./components/invoices/advancePayments/AdvancePayments";
import ProcessedTransactions from "./components/bank/processedTransactions/ProcessedTransactions";
import UnprocessedTransactions from "./components/bank/unprocessedTransactions/UnprocessedTransactions";
import UnrecognizedTransactions from "./components/bank/unrecognizedTransactions/UnrecognizedTransactions";

const EmployeeTasks = React.lazy(
    () => import("./components/mobile/EmployeeTasks")
);

const Dashboard = React.lazy(
    () => import("./components/dashboard/Dashboard")
);

const Categories = React.lazy(
    () => import("./components/nomenclatures/categories/Categories")
);

const Branches = React.lazy(
    () => import("./components/nomenclatures/branches/Branches")
);

const UnmatchedInvoices = React.lazy(
    () => import("./components/invoices/unmatchedInvoices/UnmatchedInvoices")
);

const ClientDashboard = React.lazy(
    () => import("./components/clients/ClientDashboard")
);

const ClientPrices = React.lazy(
    () => import("./components/nomenclatures/clientPrices/ClientPrices")
);

const Settings = React.lazy(
    () => import("./components/clients/settings/Settings")
);

const PenaltyInvoices = React.lazy(
    () => import("./components/invoices/PenaltyInvoices")
);

const ManualInvoices = React.lazy(
    () => import("./components/invoices/manualInvoices/ManualInvoices")
);


const Clients = React.lazy(
    () => import("./components/nomenclatures/clients/Clients")
);
const Sites = React.lazy(
    () => import("./components/nomenclatures/sites/Sites")
);
const Employees = React.lazy(
    () => import("./components/nomenclatures/employees/Employees")
);
const Vehicles = React.lazy(
    () => import("./components/nomenclatures/vehicles/Vehicles")
);
const Products = React.lazy(
    () => import("./components/nomenclatures/products/Products")
);
const MeasuringUnits = React.lazy(
    () => import("./components/nomenclatures/measuringUnits/MeasuringUnits")
);
const Requests = React.lazy(() => import("./components/requests/Requests"));
const Tasks = React.lazy(() => import("./components/tasks/Tasks"));
const Administration = React.lazy(
    () => import("./components/administration/Administration")
);
const TasksOrder = React.lazy(() => import("./components/tasks/TasksOrder"));
const Invoices = React.lazy(() => import("./components/invoices/Invoices"));
const PriceRegister = React.lazy(
    () => import("./components/clients/PriceRegister")
);

//Card System
const CardSystemCards = React.lazy(
    () => import("./components/card-system/cards/CardSystemCards")
);
const CardSystemClients = React.lazy(
    () => import("./components/card-system/clients/CardSystemClients")
);
const CardSystemProducts = React.lazy(
    () => import("./components/card-system/products/CardSystemProducts")
);
const CardSystemBranches = React.lazy(
    () => import("./components/card-system/branches/CardSystemBranches")
);
const CardSystemPrices = React.lazy(
    () => import("./components/card-system/prices/CardSystemPrices")
);

const CardSystemTransactions = React.lazy(
    () => import("./components/card-system/transactions/CardSystemTransactions")
);

const CardSystemInvoices = React.lazy(
    () => import("./components/card-system/invoices/CardSystemInvoices")
);

//Viamons
const ViamonsCards = React.lazy(
    () => import("./components/viamons/cards/ViamonsCards")
);

const ViamonsTransactions = React.lazy(
    () => import("./components/viamons/transactions/ViamonsTransactions")
);

const ViamonsInvoices = React.lazy(
    () => import("./components/viamons/invoices/ViamonsInvoices")
);

// Pos

const DiscountGroups = React.lazy(
    () => import("./components/card-system/discounts/CardSystemDiscountGroups")
);

const PosDashboard = React.lazy(
    () => import("./components/pos/PosDashboard")
);

const PosTransactions = React.lazy(
    () => import("./components/pos/PosTransactions")
);

// Reports
const Reports = React.lazy(
    () => import("./components/reports/Reports")
);

const InvoicePaymentsReport = React.lazy(
    () => import("./components/reports/InvoicePaymentsReport")
);

const ScheduleReport = React.lazy(
    () => import("./components/reports/ScheduleReport")
);

const LiabilitiesReport = React.lazy(
    () => import("./components/reports/LiabilitiesReport")
);

const EmployeeSchedule = React.lazy(
    () => import("./components/mobile/schedule/EmployeeSchedule")
);

const AuditReport = React.lazy(
    () => import("./components/reports/AuditReport")
);
const Vouchers = React.lazy(
    () => import("./components/vouchers/Vouchers")
);


// const UnmatchedPayments = React.lazy(() => import("./components/invoices/UnmatchedInvoices"));

const LogoWrapper = styled.div`
    justify-content: center;
    display: flex;
    flex-grow: 10;
`;

const TopbarElementsWrapper = styled.div`
    display: flex;
    gap: 0.5rem;
    justify-content: end;
    align-items: center;
    width: calc(100% - 50px);
`;

const LogoImage = styled.img`
    height: 60px;
    cursor: pointer;
`;

const FontSizeChangerWrapper = styled.div`
    display: flex;
    align-items: center;
    //background-color: rgba(240, 248, 255, 0.89);
    background: var(--surface-ground);
    border-radius: 8px;
    font-size: 16px !important;
`;

export const App = () => {
    const {
        userInfo: {authenticated, roles, theme},
        updateUserInfo, isMobile
    } = useUserInfo();
    const {formatMessage: f} = useIntl();
    configureApp(f);
    const navigate = useNavigate();
    const [sidebarItems, setSidebarItems] = useState<SidebarItem[]>([]);
    const [routes, setRoutes] = useState<any>();
    const [fontSize, setFontSize] = useState<number>();
    const authService = new AuthService();
    const {pathname} = useLocation();

    const [itemsPathMap, setItemsPathMap] = useState({
        "^\\/$": "home",
        "^\\/nomenclatures$": "nomenclatures",
        "^\\/nomenclatures\\/clients$": "clients",
        "^\\/nomenclatures\\/client-prices$": "client-prices",
        "^\\/nomenclatures\\/sites$": "sites",
        "^\\/nomenclatures\\/employees$": "employees",
        "^\\/nomenclatures\\/vehicles$": "vehicles",
        "^\\/nomenclatures\\/products$": "products",
        "^\\/nomenclatures\\/measuring-units$": "measuring-units",
        "^\\/nomenclatures\\/categories$": "categories",
        "^\\/nomenclatures\\/branches$": "branches",
        "^\\/requests$": "requests",
        "^\\/price-register$": "price-register",
        "^\\/tasks$": "tasks",
        "^\\/administration$": "administration",
        "^\\/invoicesMain$": "invoices-main",
        "^\\/invoices$": "invoices",
        "^\\/advancePayments$": "advancePayments",
        "^\\/unmatchedInvoices$": "unmatched-invoices",
        "^\\/penaltyInvoices$": "penalty-invoices",
        "^\\/manualInvoices$": "manual-invoices",
        "^\\/settings$": "settings",
        "^\\/card-system\\/cards$": "card-system-cards",
        "^\\/card-system\\/products$": "card-system-products",
        "^\\/card-system\\/clients$": "card-system-clients",
        "^\\/card-system\\/branches": "card-system-branches",
        "^\\/card-system\\/prices": "card-system-prices",
        "^\\/card-system\\/discount-groups": "card-system-discount-groups",
        "^\\/card-system\\/transactions": "card-system-transactions",
        "^\\/card-system\\/invoices": "card-system-invoices",
        "^\\/card-system$": "card-system",
        "^\\/viamons\\/cards$": "viamons-cards",
        "^\\/viamons\\/transactions": "viamons-transactions",
        "^\\/viamons\\/invoices": "viamons-invoices",
        "^\\/viamons$": "viamons",
        "^\\/vouchers$": "vouchers",
        "^\\/pos\\/transactions$": "pos-transactions",
        "^\\/reports": "reports",
        "^\\/bank$": "bank",
        "^\\/bank\\/unrecognized-transactions$": "bank-unrecognized-transactions",
        "^\\/bank\\/unprocessed-transactions$": "bank-unprocessed-transactions",
        "^\\/bank\\/processed-transactions$": "bank-processed-transactions",

    });

    const {data: cardsWithoutDiscountGroup} = useSWR<CSCardResponse[]>((roles && roles.includes('admin') && authenticated) ? '/cs/cards/no-discount-group' : null);
    const {data: userData, error: checkIfAuthenticatedError} = useSWR<
        LoginResponse,
        Error
    >("/auth/checkIfAuthenticated");

    useEffect(() => {
        if (userData) {
            updateUserInfo({...userData, authenticated: true});
        }
    }, [userData]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const manageNotificationPermission = () => {
        if (!("Notification" in window)) {
            // Check if the browser supports notifications
            console.warn("This browser does not support desktop notification");
        } else if (Notification.permission === "granted") {
            // Check whether notification permissions have already been granted;
            // if so, create a notification
            // const notification = new Notification("Hi there!");
            console.log("Notification permission is granted");
            // …
        } else if (Notification.permission !== "denied") {
            // We need to ask the user for permission
            Notification.requestPermission().then((permission) => {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    console.log("Notification permission is granted successfully");
                    // …
                } else {
                    console.log("Notification permission is blocked");
                }
            });
        }

        // At last, if the user has denied notifications, and you
        // want to be respectful there is no need to bother them anymore.
    };

    useEffect(() => {
        manageNotificationPermission();
    }, []);

    useEffect(() => {
        if (!roles) return;
        const sidebarItems = [];
        const home: SidebarItem = {
            id: "home",
            className: "fal fa-home",
            label: f({id: "home"}),
            command: () => navigate("/"),
        };
        const nomenclatures: SidebarItem = {
            id: "nomenclatures",
            className: "fal fa-rectangle-list",
            label: f({id: "nomenclatures"}),
            command: () => 0,
            children: [
                {
                    id: "clients",
                    className: "fal fa-address-book",
                    label: f({id: "clientRegister"}),
                    command: () => navigate("/clients"),
                },
                {
                    id: "client-prices",
                    className: "fal fa-dollar",
                    label: f({id: "clientPriceRegister"}),
                    command: () => navigate("/client-prices"),
                },
                {
                    id: "sites",
                    className: "fal fa-map-location-dot",
                    label: f({id: "siteRegister"}),
                    command: () => navigate("/sites"),
                },
                {
                    id: "employees",
                    className: "fal fa-user-group",
                    label: f({id: "employeeRegister"}),
                    command: () => navigate("/employees"),
                },
                {
                    id: "vehicles",
                    className: "fal fa-truck",
                    label: f({id: "vehicleRegister"}),
                    command: () => navigate("/vehicles"),
                },
                {
                    id: "products",
                    className: "fal fa-fire-flame-simple",
                    label: f({id: "productRegister"}),
                    command: () => navigate("/products"),
                },
                {
                    id: "measuring-units",
                    className: "fal fa-ruler",
                    label: f({id: "measuringUnitRegister"}),
                    command: () => navigate("/measuring-units"),
                },
                {
                    id: "categories",
                    className: "fal fa-layer-group",
                    label: f({id: "categoryRegister"}),
                    command: () => navigate("/categories"),
                },
                {
                    id: "branches",
                    className: "fal fa-building",
                    label: f({id: "branchRegister"}),
                    command: () => navigate("/branches"),
                },
            ],
        };
        const requests: SidebarItem = {
            id: "requests",
            className: "fal fa-file-lines",
            label: f({id: "requests"}),
            command: () => navigate("/requests"),
        };
        const tasks: SidebarItem = {
            id: "tasks",
            className: "fal fa-list-check",
            label: f({id: "tasks"}),
            command: () => navigate("/tasks"),
        };
        const administration: SidebarItem = {
            id: "administration",
            className: "fal fa-gear",
            label: f({id: "administration"}),
            command: () => navigate("/administration"),
        };

        const employeeTasks: SidebarItem = {
            id: "employee-tasks",
            className: "fal fa-list-check",
            label: f({id: "tasks"}),
            command: () => navigate("/"),
        };

        const employeeSchedule: SidebarItem = {
            id: "employee-schedule",
            className: "fal fa-calendar-days",
            label: f({id: "schedule"}),
            command: () => navigate("/schedule"),
        };

        const invoices: SidebarItem = {
            id: "invoices-main",
            className: "fal fa-receipt",
            label: f({id: "invoices"}),
            command: () => 0,
            children: [
                {
                    id: "invoices",
                    className: "fal fa-file-invoice",
                    label: f({id: "invoices"}),
                    command: () => navigate("/invoices"),
                },
                {
                    id: "advancePayments",
                    className: "fal fa-wallet",
                    label: f({id: "advancePayments"}),
                    command: () => navigate("/advancePayments"),
                },
                {
                    id: "manual-invoices",
                    className: "fal fa-file-pen",
                    label: f({id: "manualInvoices"}),
                    command: () => navigate("/manualInvoices"),
                },
                {
                    id: "unmatched-invoices",
                    className: "fal fa-file-xmark",
                    label: f({id: "unmatchedInvoices"}),
                    command: () => navigate("/unmatchedInvoices"),
                },
                {
                    id: "penalty-invoices",
                    className: "fal fa-file-xmark",
                    label: f({id: "penaltyInvoices"}),
                    command: () => navigate("/penaltyInvoices"),
                },
            ],
        };
        const priceRegister: SidebarItem = {
            id: "price-register",
            className: "fal fa-list-check",
            label: f({id: "priceRegister"}),
            command: () => navigate("/price-register"),
        };

        const settings: SidebarItem = {
            id: 'settings',
            className: 'fal fa-cog',
            label: f({id: 'settings'}),
            command: () => navigate('/settings')
        }

        const cardsWithoutDiscountGroupExist = cardsWithoutDiscountGroup !== undefined && Array.isArray(cardsWithoutDiscountGroup) && cardsWithoutDiscountGroup.length > 0;
        const cardSystem: SidebarItem = {
            id: 'card-system',
            className: cardsWithoutDiscountGroupExist ? 'fal fa-triangle-exclamation problem-icon' : 'fal fa-cash-register',
            label: f({id: 'cardSystem'}),
            command: () => 0,
            children: [
                {
                    id: 'card-system-cards',
                    className: cardsWithoutDiscountGroupExist ? 'fal fa-triangle-exclamation problem-icon' : 'fal fa-address-card',
                    label: f({id: 'cards'}),
                    command: () => navigate('/card-system/cards')
                },
                {
                    id: 'card-system-clients',
                    className: 'fal fa-address-book',
                    label: f({id: 'clients'}),
                    command: () => navigate('/card-system/clients')
                },
                {
                    id: "card-system-discount-groups",
                    className: "fal fa-percent",
                    label: f({id: "discountGroups"}),
                    command: () => navigate("/card-system/discount-groups"),
                },
                {
                    id: "card-system-prices",
                    className: "fal fa-coins",
                    label: f({id: "prices"}),
                    command: () => navigate("/card-system/prices"),
                },
                {
                    id: 'card-system-products',
                    className: 'fal fa-fire-flame-simple',
                    label: f({id: 'products'}),
                    command: () => navigate('/card-system/products')
                },
                {
                    id: "card-system-branches",
                    className: "fal fa-building",
                    label: f({id: "branches"}),
                    command: () => navigate("/card-system/branches"),
                },
                {
                    id: "card-system-transactions",
                    className: "fal fa-right-left",
                    label: f({id: "transactions"}),
                    command: () => navigate("/card-system/transactions")
                },
                {
                    id: "card-system-invoices",
                    className: "fal fa-file-invoice",
                    label: f({id: "invoices"}),
                    command: () => navigate("/card-system/invoices")
                }

            ]
        }

        const viamons: SidebarItem = {
            id: 'viamons',
            className: 'fal fa-gas-pump',
            label: f({id: 'viamons'}),
            command: () => 0,
            children: [
                {
                    id: 'viamons-cards',
                    className: 'fal fa-address-card',
                    label: f({id: 'chips'}),
                    command: () => navigate('/viamons/cards')
                },
                {
                    id: 'viamons-transactions',
                    className: "fal fa-right-left",
                    label: f({id: 'transactions'}),
                    command: () => navigate('/viamons/transactions')
                },
                {
                    id: 'viamons-invoices',
                    className: "fal fa-file-invoice",
                    label: f({id: 'invoices'}),
                    command: () => navigate('/viamons/invoices')
                },
            ]
        }

        const bank: SidebarItem = {
            id: 'bank',
            className: 'fal fa-money-bill',
            label: f({id: 'bank'}),
            command: () => 0,
            children: [
                {
                    id: 'bank-unprocessed-transactions',
                    className: 'fal fa-clock',
                    label: f({id: 'unprocessedTransactions'}),
                    command: () => navigate('/bank/unprocessed-transactions')
                },
                {
                    id: 'bank-processed-transactions',
                    className: 'fal fa-circle-check',
                    label: f({id: 'processedTransactions'}),
                    command: () => navigate('/bank/processed-transactions')
                },
                {
                    id: 'bank-unrecognized-transactions',
                    className: 'fal fa-circle-exclamation',
                    label: f({id: 'unrecognizedTransactions'}),
                    command: () => navigate('/bank/unrecognized-transactions')
                },
            ]
        }

        const posTransactions = {
            id: 'pos-transactions',
            className: 'fal fa-right-left',
            label: f({id: "transactions"}),
            command: () => navigate("/pos/transactions")
        }

        const reports = {
            id: 'reports',
            className: 'fal fa-file-chart-column',
            label: f({id: "reports"}),
            command: () => navigate("/reports")
        }

        const vouchers = {
            id: 'vouchers',
            className: 'fal fa-ticket',
            label: f({id: "vouchers"}),
            command: () => navigate("/vouchers")
        }

        if (roles && roles.includes("admin")) {
            setItemsPathMap((prevState) => {
                return {...prevState, ["^\\/$"]: "home"};
            });
            sidebarItems.push(
                home,
                nomenclatures,
                requests,
                tasks,
                invoices,
                cardSystem,
                viamons,
                reports,
                administration
            );
        } else if (roles && roles.includes("employee")) {
            setItemsPathMap((prevState) => {
                return {...prevState, ["^\\/$"]: "employee-tasks", "^\\/schedule$": "employee-schedule"};
            });
            sidebarItems.push(employeeTasks);
            sidebarItems.push(employeeSchedule);
        } else if (roles && roles.includes("client")) {
            setItemsPathMap((prevState) => {
                return {...prevState, ["^\\/$"]: "home"};
            });
            sidebarItems.push(home, priceRegister, settings);
        } else if (roles && roles.includes("pos")) {
            setItemsPathMap((prevState) => {
                return {...prevState, ["^\\/$"]: "home"};
            });
            sidebarItems.push(home, posTransactions);
        }
        if (roles && roles.includes("vouchers")) {
            sidebarItems.splice(6, 0, vouchers);
        }
        if (roles && roles.includes("bank")) {
            sidebarItems.splice(7, 0, bank);
        }
        setSidebarItems(sidebarItems);
    }, [roles, cardsWithoutDiscountGroup]);

    function* gen() {
        let counter = 1;
        while (true) yield counter++;
    }

    useEffect(() => {
        const generator = gen();
        const routes = [];
        //Administrator routes
        const home = (
            <Route key={+generator.next().value} index element={<Dashboard/>}/>
        );
        const clients = (
            <Route
                key={+generator.next().value}
                path={"/clients"}
                element={<Clients/>}
            />
        );
        const clientPrices = (
            <Route
                key={+generator.next().value}
                path={"/client-prices"}
                element={<ClientPrices/>}
            />
        );
        const sites = (
            <Route
                key={+generator.next().value}
                path={"/sites"}
                element={<Sites/>}
            />
        );
        const employees = (
            <Route
                key={+generator.next().value}
                path={"/employees"}
                element={<Employees/>}
            />
        );
        const vehicles = (
            <Route
                key={+generator.next().value}
                path={"/vehicles"}
                element={<Vehicles/>}
            />
        );
        const products = (
            <Route
                key={+generator.next().value}
                path={"/products"}
                element={<Products/>}
            />
        );
        const measuringUnits = (
            <Route
                key={+generator.next().value}
                path={"/measuring-units"}
                element={<MeasuringUnits/>}
            />
        );
        const requests = (
            <Route
                key={+generator.next().value}
                path={"/requests"}
                element={<Requests/>}
            />
        );
        const tasks = (
            <Route
                key={+generator.next().value}
                path={"/tasks"}
                element={<Tasks/>}
            />
        );
        const invoices = (
            <Route
                key={+generator.next().value}
                path={"/invoices"}
                element={<Invoices previewOnly={false}/>}
            />
        );
        const advancePayments = (
            <Route
                key={+generator.next().value}
                path={"/advancePayments"}
                element={<AdvancePayments/>}
            />
        );
        const manualInvoices = (
            <Route
                key={+generator.next().value}
                path={"/manualInvoices"}
                element={<ManualInvoices/>}
            />
        );
        const unmatchedInvoices = (
            <Route
                key={+generator.next().value}
                path={"/unmatchedInvoices"}
                element={<UnmatchedInvoices/>}
            />
        );
        const penaltyInvoices = (
            <Route
                key={+generator.next().value}
                path={"/penaltyInvoices"}
                element={<PenaltyInvoices/>}
            />
        );
        const administration = (
            <Route
                key={+generator.next().value}
                path={"/administration"}
                element={<Administration/>}
            />
        );
        const tasksOrder = (
            <Route
                key={+generator.next().value}
                path={"/tasks/order"}
                element={<TasksOrder/>}
            />
        );
        const categories = (
            <Route
                key={+generator.next().value}
                path={"/categories"}
                element={<Categories/>}
            />
        );
        const branches = (
            <Route
                key={+generator.next().value}
                path={"/branches"}
                element={<Branches/>}
            />
        );
        const notFound = (
            <Route key={+generator.next().value} path="*" element={<NotFound/>}/>
        );

        //Employee routes
        const employeeTasks = (
            <Route key={+generator.next().value} index element={<EmployeeTasks/>}/>
        );

        const employeeSchedule = (
            <Route key={+generator.next().value} path={'/schedule'} element={<EmployeeSchedule/>}/>
        );

        //Client routes
        const clientDashboard = (
            <Route
                key={+generator.next().value}
                index
                element={<ClientDashboard/>}
            />
        );
        const priceRegister = (
            <Route
                key={+generator.next().value}
                path={"/price-register"}
                element={<PriceRegister/>}
            />
        );

        const settings = (
            <Route
                key={+generator.next().value}
                path={"/settings"}
                element={<Settings/>}
            />
        );

        //Card System
        const cardSystemCards = (
            <Route
                key={+generator.next().value}
                path={"/card-system/cards"}
                element={<CardSystemCards/>}
            />
        );

        const cardSystemClients = (
            <Route
                key={+generator.next().value}
                path={'/card-system/clients'}
                element={<CardSystemClients/>}
            />
        );

        const cardSystemProducts = (
            <Route
                key={+generator.next().value}
                path={'/card-system/products'}
                element={<CardSystemProducts/>}
            />
        );

        const cardSystemBranches = (
            <Route
                key={+generator.next().value}
                path={'/card-system/branches'}
                element={<CardSystemBranches/>}
            />
        );

        const cardSystemPrices = (
            <Route
                key={+generator.next().value}
                path={'/card-system/prices'}
                element={<CardSystemPrices/>}
            />
        );

        const cardSystemDiscountGroups = (
            <Route
                key={+generator.next().value}
                path={'/card-system/discount-groups'}
                element={<DiscountGroups/>}
            />
        );

        const cardSystemTransactions = (
            <Route
                key={+generator.next().value}
                path={'/card-system/transactions'}
                element={<CardSystemTransactions/>}
            />
        );

        const cardSystemInvoices = (
            <Route
                key={+generator.next().value}
                path={'/card-system/invoices'}
                element={<CardSystemInvoices/>}
            />
        );

        //Viamons
        const viamonsCards = (
            <Route
                key={+generator.next().value}
                path={"/viamons/cards"}
                element={<ViamonsCards/>}
            />
        );

        const viamonsTransactions = (
            <Route
                key={+generator.next().value}
                path={"/viamons/transactions"}
                element={<ViamonsTransactions/>}
            />
        );

        const viamonsInvoices = (
            <Route
                key={+generator.next().value}
                path={'/viamons/invoices'}
                element={<ViamonsInvoices/>}
            />
        );

        //Pos
        const posDashBoard = (
            <Route
                key={+generator.next().value}
                index
                element={<PosDashboard/>}
            />
        );

        const posTransactions = (
            <Route
                key={+generator.next().value}
                path={'/pos/transactions'}
                element={<PosTransactions/>}
            />
        );

        //Reports
        const reports = (
            <Route
                key={+generator.next().value}
                path={'/reports'}
                element={<Reports/>}
            />
        );

        const invoicePaymentsReport = (
            <Route
                key={+generator.next().value}
                path={'/reports/payments'}
                element={<InvoicePaymentsReport/>}
            />
        );

        const scheduleReport = (
            <Route
                key={+generator.next().value}
                path={'/reports/schedule'}
                element={<ScheduleReport/>}
            />
        );

        const liabilitiesReport = (
            <Route
                key={+generator.next().value}
                path={'/reports/liabilities'}
                element={<LiabilitiesReport/>}
            />
        );

        const auditReport = (
            <Route
                key={+generator.next().value}
                path={'/reports/audit'}
                element={<AuditReport/>}
            />
        );

        //Vouchers

        const vouchers = (
            <Route
                key={+generator.next().value}
                path={'/vouchers'}
                element={<Vouchers/>}
            />
        );

        //Bank
        const bankProcessedTransactions = (
            <Route
                key={+generator.next().value}
                path={'/bank/processed-transactions'}
                element={<ProcessedTransactions/>}
            />
        );

        const bankUnprocessedTransactions = (
            <Route
                key={+generator.next().value}
                path={'/bank/unprocessed-transactions'}
                element={<UnprocessedTransactions/>}
            />
        );

        const bankUnrecognizedTransactions = (
            <Route
                key={+generator.next().value}
                path={'/bank/unrecognized-transactions'}
                element={<UnrecognizedTransactions/>}
            />
        );


        if (roles) {
            if (roles.includes("admin")) {
                routes.push(
                    home,
                    clients,
                    clientPrices,
                    sites,
                    employees,
                    vehicles,
                    products,
                    measuringUnits,
                    categories,
                    requests,
                    tasks,
                    invoices,
                    advancePayments,
                    manualInvoices,
                    unmatchedInvoices,
                    penaltyInvoices,
                    branches,
                    administration,
                    tasksOrder,
                    cardSystemCards,
                    cardSystemClients,
                    cardSystemProducts,
                    cardSystemBranches,
                    cardSystemPrices,
                    cardSystemDiscountGroups,
                    cardSystemTransactions,
                    cardSystemInvoices,
                    vouchers,
                    reports,
                    invoicePaymentsReport,
                    scheduleReport,
                    liabilitiesReport,
                    auditReport,
                    viamonsCards,
                    viamonsTransactions,
                    viamonsInvoices
                );
                // if (roles.includes("bank")) {
                routes.push(bankProcessedTransactions);
                routes.push(bankUnprocessedTransactions);
                routes.push(bankUnrecognizedTransactions);
                // }

                if (roles.includes("vouchers")) {
                    routes.push(vouchers);
                }

            } else if (roles.includes("employee")) {
                routes.push(employeeTasks);
                routes.push(employeeSchedule);
            } else if (roles.includes("client")) {
                routes.push(clientDashboard, priceRegister, settings);
            } else if (roles.includes("pos")) {
                routes.push(posDashBoard, posTransactions);
            }
            routes.push(notFound);
        }
        setRoutes(routes);
    }, [roles]);

    const handleLogoClick = () => {
        navigate("/");
        document
            .querySelector(".rb-sidebar-active")
            ?.classList.toggle("rb-sidebar-active");
    };

    const handleLogout = () => {
        authService.logout().then(() => {
            navigate("/");
            updateUserInfo({
                authenticated: false,
                userId: undefined,
                roles: [],
                username: undefined,
            });
        });
    };

    const changeFontSize = (direction: "up" | "down") => {
        // const html = document.documentElement;
        if (direction === "up") {
            // html.style.fontSize = parseInt(html.style.fontSize) + 1 + 'px';
            setFontSize((prev) => prev! + 1);
        } else {
            // html.style.fontSize = parseInt(html.style.fontSize) - 1 + 'px';
            setFontSize((prev) => prev! - 1);
        }
    };

    useEffect(() => {
        const fontSizeFromStorage = localStorage.getItem("font-size");
        if (fontSizeFromStorage !== null) setFontSize(+fontSizeFromStorage);
        else setFontSize(16);
    }, []);

    useEffect(() => {
        if (fontSize !== undefined) {
            const html = document.documentElement;
            html.style.fontSize = fontSize + "px";
            localStorage.setItem("font-size", fontSize.toString());
        }
    }, [fontSize]);

    const fontSizeChanger = (
        <FontSizeChangerWrapper>
            <Button
                text
                icon="pi pi-sort-alpha-down"
                onClick={() => changeFontSize("down")}
            />
            <label>{fontSize} px</label>
            <Button
                text
                icon="pi pi-sort-alpha-up"
                onClick={() => changeFontSize("up")}
            />
        </FontSizeChangerWrapper>
    );

    const topbarElements = (
        <TopbarElementsWrapper>
            <LogoWrapper>
                <LogoImage onClick={handleLogoClick} src={png}/>
            </LogoWrapper>
            {isMobile ? null : <ThemeSwitch/>}
            {roles && roles.includes("pos") && <Button icon={'pi pi-refresh'} size={"small"} severity={"info"}
                                                       style={{height: '2.5rem', alignSelf: 'center'}} type={'button'}
                                                       onClick={() => location.reload()}/>}
            {fontSizeChanger}
            <Button
                style={{background: "transparent", border: "0px"}}
                icon="fa-solid fa-right-from-bracket"
                onClick={handleLogout}
            />
        </TopbarElementsWrapper>
    );

    if (userData === undefined && !checkIfAuthenticatedError) return null;

    return (
        <>
            {!authenticated ? (
                <Login/>
            ) : (
                <>
                    <React.Suspense fallback={<Circles customLoading={true}/>}>
                        {sidebarItems.length > 0 ? (
                            <div className={theme === "light" ? "layout-white" : "layout-dark"}>
                                <Sidebar
                                    items={sidebarItems}
                                    topbarStyle={{background: "var(--primary-400)"}}
                                    topBarElement={topbarElements}
                                    collapseIcon={"fa fa-chevron-up"}
                                    expandIcon={"fa fa-chevron-down"}
                                    locationPath={pathname}
                                    itemPathsMap={itemsPathMap}
                                >

                                    <Routes>{routes ? routes.map((el: any) => el) : null}</Routes>

                                    <Footer/>
                                </Sidebar>
                            </div>
                        ) : null}
                    </React.Suspense>
                </>
            )}
        </>
    );
};

export default App;
